import api from '@/shared/services/api';
import types from './types.js';
import router from '../router/index.js';
import routerNames from '../router/router-names.js';

/// POST remote API
/// ***********************************************
const getLoanEnquiryConfig = async function () { return postRequest(types.LOAN_ENQUIRY_CONFIGURATION_READ, null, routerNames.Timeout); };
const saveLoanEnquiry = async function (payload) { return postRequest(types.LOAN_ENQUIRY_CREATE, payload) };
const checkEligibility = async function (payload) { return postRequest(types.LOAN_ENQUIRY_CHECK_ELIGIBILITY, payload); };
const otpRequest = async function (payload) { return postRequest(types.LOAN_ENQUIRY_OTP_REQUEST, payload); };
const otpValidate = async function (payload) { return postRequest(types.LOAN_ENQUIRY_OTP_VALIDATE, payload); };
const requestOpen = async function (payload) { return postRequest(types.LOAN_ENQUIRY_REQUEST_OPEN, payload); };
const openEnquiry = async function (payload) { return postRequest(types.LOAN_ENQUIRY_OPEN_ENQUIRY, payload); };
const enquiryDoc = async function (payload) { return postRequest(types.LOAN_ENQUIRY_ENQUIRY_DOCUMENT, payload); };
const enquiryIdVerification = async function (payload) { return postRequest(types.LOAN_ENQUIRY_ENQUIRY_ID_VERIFICATION, payload); };
const generateSignature = async function (payload) { return postRequest(types.LOAN_ENQUIRY_GENERATE_SIGNATURE, payload); };

/// Generic Post Request
/// Returns: False or Response Data
/// **************************************************
const postRequest = async function (action, payload, errorRoute = routerNames.Error) {
  try {
    return parseResponse(await api.post(types.apiRoot + action, payload));
  }
  catch (error) {
    console.error(error);
    router.push({ name: errorRoute });
    return false;
  }
};

/// Parse JSON response
/// ***************************
const parseResponse = response => {
  if (response.status !== 200) throw Error(response.message);
  return !response.data || typeof response.data != 'object' ? [] : response.data;
};

export const service = {
  getLoanEnquiryConfig,
  saveLoanEnquiry,
  checkEligibility,
  otpRequest,
  otpValidate,
  requestOpen,
  openEnquiry,
  enquiryDoc,
  enquiryIdVerification,
  generateSignature
};